import { makeStyles, MenuItem, Select, Typography } from '@material-ui/core';
import i18n from 'i18n';
import React from 'react';
import { conditionOperators, ConditionOperatorsEnum } from 'utils/filters';
import styles from './styles';

interface Props {
  options: ConditionOperatorsEnum[];
  value: ConditionOperatorsEnum;
  onChange: (operator: ConditionOperatorsEnum) => void;
}

const ConditionOperatorSelect = ({ options, value, onChange }: Props) => {
  const classes = makeStyles(styles)();

  return (
    <Select
      disableUnderline
      variant="standard"
      className={classes.select}
      renderValue={v => `${v}`}
      value={value}
      onChange={e => onChange(e.target.value as ConditionOperatorsEnum)}
    >
      {options?.map(operator => {
        const { label } = conditionOperators[operator];

        return (
          <MenuItem key={operator} value={operator}>
            <Typography className={classes.smallFontSize}>
              {i18n.t(label)}
            </Typography>
          </MenuItem>
        );
      })}
    </Select>
  );
};

export default ConditionOperatorSelect;
